import './loader.scss';

type Props = {
  className?: string;
};

const Spinner = ({ className }: Props) => (
  <div className={`${className} loading-spinner`}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default Spinner;
